import React from "react";
import PropTypes from 'prop-types';
import { Box, Container, useMediaQuery } from "@mui/material";
import { ControlPageTitle, ControlPageDescription,  } from "../components/board";


export default function ContentLayout (props) {
    const { pageTitle, pageDescription, pd, children, addClassName, pageTitleIcon } = props;
    const isxsMobile = useMediaQuery('(max-width:320px)');
    const issMobile = useMediaQuery('(max-width:410px)');
    const isMobile = useMediaQuery('(max-width:600px)');
    const isSm = useMediaQuery('(max-width:900px)');
    const isMd = useMediaQuery('(max-width:1200px)');

    const getPadding = () => {
        if (pd && pd.Length > 0) return pd; // Custom padding if provided
        if (isxsMobile) return "7px";
        if (issMobile) return "11px";
        if (isMobile) return "15px";
        if (isSm) return "19px";
        if (isMd) return "25px";
        return "25px"; // Default padding for larger screens
    }

    return (
        <Box className={`content-layout-box ${addClassName || 'content-layout-sub'}`}>
            <Container variant='section' className="content-layout" sx={{ alignItems: 'center', p: 0, }} maxWidth="lg">
                <div style={{ paddingRight: pd || getPadding(), paddingLeft: pd || getPadding(), paddingTop: "15px", paddingBottom: "15px" }}>

                    {/* 페이지 제목 */}
                    {pageTitle ? 
                    <ControlPageTitle className="page-title" pageTitle={pageTitle} pageTitleIcon={pageTitleIcon} /> : null}

                    {/* 부제 출력 */}
                    {pageDescription ?
                    <ControlPageDescription  className="page-description" pageDescription={pageDescription} /> : null}

                    <div className="page-blank-block" />

                    {children}
                    
                </div>
            </Container>
        </Box>
    );
};

ContentLayout.propTypes = {
    pageTitle: PropTypes.string,
    pageDescription: PropTypes.string,
    pd: PropTypes.string,
    children: PropTypes.node,
    addClassName: PropTypes.string,
    pageTitleIcon: PropTypes.object, // FontAwesomeIcon object
};